import React from "react";
import styled from "styled-components";

const SubscriptionSummaryBar = ({ planName, itemCount, interval, totalAmount, pendingCancelCount = 0}) => {
  const activeCount = itemCount - pendingCancelCount;

  return (
    <SummaryBar>
      {planName && (
        <>
          <SummaryItem>
            <SummaryLabel>Subscription</SummaryLabel>
            <SummaryValue>{planName}</SummaryValue>
          </SummaryItem>
          <SummaryDivider />
        </>
      )}
      <SummaryItem>
        <SummaryLabel>Active Products</SummaryLabel>
        <SummaryValueRow>
          <SummaryValue>{activeCount}</SummaryValue>
          {pendingCancelCount > 0 && (
            <PendingBadge>
              {pendingCancelCount} canceling
            </PendingBadge>
          )}
        </SummaryValueRow>
      </SummaryItem>
      <SummaryDivider />
      <SummaryItem>
        <SummaryLabel>Billing Cycle</SummaryLabel>
        <SummaryValue>{interval === "year" ? "Yearly" : "Monthly"}</SummaryValue>
      </SummaryItem>
      <SummaryDivider />
      <SummaryItem>
        <SummaryLabel>Total per cycle</SummaryLabel>
        <SummaryValueHighlight>{totalAmount}</SummaryValueHighlight>
      </SummaryItem>
    </SummaryBar>
  );
};

export default SubscriptionSummaryBar;

const SummaryBar = styled.div`
  display: flex;
  align-items: center;
  background: #ffffff;
  border: 1px solid #e9eaeb;
  border-radius: 12px;
  padding: 14px 24px;
  box-shadow: 0 1px 2px rgba(10, 13, 18, 0.04);
  width: fit-content;

  @media (max-width: 768px) {
    width: 100%;
    flex-wrap: wrap;
    gap: 12px;
    padding: 14px 16px;
  }
`;

const SummaryItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  padding: 0 24px;

  &:first-child {
    padding-left: 0;
  }

  @media (max-width: 768px) {
    padding: 0 12px;
  }
`;

const SummaryDivider = styled.div`
  width: 1px;
  align-self: stretch;
  margin: 4px 0;
  background: #e9eaeb;
  flex-shrink: 0;
`;

const SummaryLabel = styled.span`
  color: #667085;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
`;

const SummaryValueRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 28px;
`;

const SummaryValue = styled.span`
  color: #181d27;
  font-size: 15px;
  font-weight: 700;
  min-height: 28px; 
  display: flex;
  align-items: center;
`;

const SummaryValueHighlight = styled.span`
  color: #7f56d9;
  font-size: 18px;
  font-weight: 800;
  letter-spacing: -0.02em;
`;

const PendingBadge = styled.span`
  background: #fff7ed;
  color: #c4320a;
  border: 1px solid #fed7aa;
  border-radius: 9999px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  padding: 2px 7px;
  line-height: 1.4;
  white-space: nowrap;
`;